import { render, staticRenderFns } from "./putInStorageShop.vue?vue&type=template&id=40807055&scoped=true"
import script from "./putInStorageShop.vue?vue&type=script&lang=ts"
export * from "./putInStorageShop.vue?vue&type=script&lang=ts"
import style0 from "./putInStorageShop.vue?vue&type=style&index=0&id=40807055&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40807055",
  null
  
)

export default component.exports